import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { usePlatformSendingStatusAlertPresent } from '@dashboard/components/PlatformSendingStatusAlert';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { Grid, SxProps } from '@mui/material';

import RequestLogList from './RequestLogList';
import useCurrentRequestLogId from './useCurrentRequestLogId';

function useContainerHeightStyle() {
  const p = usePlatformSendingStatusAlertPresent();
  if (p) {
    return 'calc(100vh - 48px - 8px - 32px)';
  }
  return 'calc(100vh - 48px - 8px )';
}

const REQUEST_LIST_STYLES: SxProps = {
  height: '100%',
  '.MuiPaper-root': {
    height: '100%',
  },
  '.MuiPaper-root > .MuiBox-root': {
    overflow: 'auto',
    height: { xs: 256, md: 'calc(100% - 53px)' },
  },
};

const REQUEST_SHOW_STYLES: SxProps = {
  height: '100%',
  '.MuiPaper-root': {
    height: '100%',
  },
};

export default function List() {
  const currentRequestId = useCurrentRequestLogId();
  const platformId = useCurrentPlatformId();
  const navigate = useNavigate();
  const containerHeight = useContainerHeightStyle();
  const { search } = useLocation();

  const setCurrentRequestId = (id: string) => {
    navigate({
      pathname: `/o/${platformId}/request-logs/${id}`,
      search,
    });
  };

  return (
    <Grid sx={{ height: { xs: 'auto', md: containerHeight } }} container spacing={3}>
      <Grid item sx={REQUEST_LIST_STYLES} xs={12} md={4}>
        <RequestLogList currentRequestId={currentRequestId} setCurrentRequestId={setCurrentRequestId} />
      </Grid>
      <Grid item sx={REQUEST_SHOW_STYLES} xs={12} md={8}>
        <Outlet />
      </Grid>
    </Grid>
  );
}
